module.exports = __webpack_public_path__ + "img/logo.62569ff6.svg";